/**
 * JSON Schema for the main object.
 *
 * http://json-schema.org/
 */
export default {
  id: "/ReportBody",
  type: "object",
  properties: {
    eventId: { type: "string" },
    report: { type: "string" },
    parameter: { $ref: "/Parameter" },
    status: { type: "string" }
  },
  required: ["report", "status"]
};
